<template>
    <template v-if="internationalContactsPage">
        <p class="contacts-sec__title">instagram</p>
        <a href="https://www.instagram.com/batnorton" class="contacts-sec__value" style="display: flex">
            batnorton
            <img class="footer__network-img footer__network" :src="'/img/svg/ic-instagram.svg'" alt="BatNorton`s Instagram">
        </a>
    </template>
    <template v-else>
        <template v-if="this.$store.state.settings.site_id == 1">
            <a href="https://www.instagram.com/batnorton_rus"
               class="footer__network">
                <img class="footer__network-img"
                     :src="'/img/svg/ic-instagram.svg'" alt=" BatNorton Instagram">
            </a>
            {{place}}
            <a href="https://www.youtube.com/channel/UCMDtG3fFfIWPZZkiseCSzHQ"
               class="footer__network">
                <img class="footer__network-img"
                     :src="'/img/svg/ic-youtybe.svg'" alt="BatNorton YouTube">
            </a>
            <a href="https://vk.com/batnorton" class="footer__network">
                <img class="footer__network-img" :src="'/img/svg/ic-vk.svg'"
                     alt="BatNorton VK">
            </a>
            <a href="https://t.me/batnorton" class="footer__network">
                <img class="footer__network-img"
                     :src="'/img/svg/ic-telegram.svg'" alt="BatNorton Telegram">
            </a>
        </template>
        <template v-if="this.$store.state.settings.site_id == 2">
            <a href="https://www.instagram.com/batnorton" class="footer__network">
                <img class="footer__network-img"
                     :src="'/img/svg/ic-instagram.svg'" alt="BatNorton`s Instagram">
            </a>
        </template>
    </template>
</template>

<script>
export default {
    // Объявляем параметры, которые компонент может принимать
    props: {
        internationalContactsPage: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    name: "Socials"
}
</script>
